<template>
  <div id="Social">
    <headNav>
      <div slot="headNavText">{{$t('message.social_info')}}</div>
    </headNav>
    <div class="container">
      <div class="bascInfoBox">
        <div>
          <div class="circle"></div>
          <div class="circle circle1">02</div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <div class="scsf">
          <div>{{$t('message.social_rz')}}</div>
          <div>{{$t('message.social_rz_tips')}}</div>
        </div>
        <div class="bascInfoContent">
          <h3>{{$t('message.contct')}}1</h3>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.name')}}</div>
            <van-field v-model="relaP1Name" :placeholder="$t('message.ipt_u_xm')"
                       @blur="isNull(relaP1Name,'tips_relaP1Name')"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.phone')}}</div>
            <van-field v-model="relaP1Tel" :placeholder="$t('message.enterPhone')"
                       @blur="isNull(relaP1Tel,'tips_relaP1Tel')" type="number"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.relation')}}</div>
            <van-field v-model="relaP1GX" :placeholder="$t('message.relation')" right-icon="arrow-down"
                       @focus="showModel('relaP1GX')"
                       readonly/>
          </div>

          <h3>{{$t('message.contct')}}2</h3>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.name')}}</div>
            <van-field v-model="relaP2Name" :placeholder="$t('message.ipt_u_xm')"
                       @blur="isNull(relaP1Name,'tips_relaP2Name')"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.phone')}}</div>
            <van-field v-model="relaP2Tel" :placeholder="$t('message.enterPhone')"
                       @blur="isNull(relaP1Tel,'tips_relaP2Tel')" type="number"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.relation')}}</div>
            <van-field v-model="relaP2GX" :placeholder="$t('message.relation')" right-icon="arrow-down"
                       @focus="showModel('relaP2GX')"
                       readonly/>
          </div>
          <div class="tips">*{{$t('message.social_rz_tips2')}}</div>
          <van-button type="primary" size="normal" round @click="subInfo" v-if="isRest==null" class="btns" block>
            {{$t('message.jx')}}
          </van-button>

          <!--重新认证-->
          <van-button type="primary" size="normal" round @click="subInfoNext" v-if="isRest!=null" :disabled="isPost"
                      class="btns" block>{{$t('message.jx')}}
          </van-button>
        </div>
      </div>
    </div>
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-picker :columns='relations' @change="onChange" @cancel="onCancel" :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
  import {postContact, zhiyeNews, sassSearchSocial, sassRestRZ, getSocialNews, postRenInfo} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "Social",
    data() {
      return {
        show: false,
        values: '',//默认值
        relaP1Name: '',//联系人1姓名
        relaP2Name: '',
        relaP1Tel: '',//联系人1电话
        relaP2Tel: '',
        relaP1GX: '',//联系人1关系
        relaP2GX: '',
        holdBankPer: '',//持卡人姓名
        holdBankIdCard: '',//联系人身份证
        bankName: '',//银行卡名称
        relations: [],
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        error_border: {
          border: '1px solid red',
          borderRadius: '4px'
        },
        tips_relaP1Name: false,
        tips_relaP2Name: false,
        tips_relaP1Tel: false,
        tips_relaP2Tel: false,
        tips_relaP1GX: false,
        tips_relaP2GX: false,
        isPost: false,
        isRest: '',//判断是否审核拒绝，需要重新认证
        total_rz: 0,//需要认证的步数
        has_rz_total: 0//已经认证的步数
      }

    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      zhiyeNews({})
        .then(res => {
          res.data.data.Contact.forEach((elem, index) => {
            this.relations.push(elem.vietnamese);
          });
        })
        .catch(err => {
          this.$store.commit('edit', false);//关闭全局的loading
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
      //拒绝后，重新修改个人数据
      this.isRest = sessionStorage.getItem('restRZ');
      if (sessionStorage.getItem('restRZ')) {
        sassSearchSocial({userid: this.tk.userid, orderid: this.$route.query.orderid})
          .then(res => {
            if (res.data.code == 200) {
              let res1 = res.data.data;
              this.relaP1Name = res1.relation_name1;
              this.relaP2Name = res1.relation_name2;
              this.relaP2GX = res1.relation2;
              this.relaP1GX = res1.relation1;
              this.relaP2Tel = res1.mobile2;
              this.relaP1Tel = res1.mobile1;
            } else {
              this.$notify({
                type: 'danger',
                message: res.data.msg,
              });
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      }
      postRenInfo({userid: this.tk.userid})
        .then(res => {
          //is_true=>1未认证 2已认证   is_display=》1显示 0不显示   is_varify=》1必须认证  0不必须认证
          res.data.data.forEach((e, i) => {
            // 获取总共的认证流程的步数
            this.total_rz++;
            // 统计非运营商步骤总共已经认证的
            if (e.is_true == 2 && e.is_varify == 1 && e.is_display == 1 && e.veriry_desc != '运营商') {
              this.has_rz_total++;
            } else if (e.veriry_desc == '运营商' && e.is_varify == 0 && e.is_true == 2) { // 排除如果运营商如果可以跳过
              this.total_rz = this.total_rz - 1;
              this.has_rz_total = this.has_rz_total + 1;
            } else if (e.veriry_desc == '运营商' && e.is_true == 2 && e.is_varify == 1 && e.is_display == 1) {
              this.has_rz_total = this.has_rz_total + 1;
            }
          });
        })
    },
    components: {
      headNav
    },
    methods: {
      //判断输入是否为空
      isNull(a, b) {
        switch (b) {
          case 'tips_relaP1Name':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP1Name = true;
            } else {
              this.tips_relaP1Name = false;
            }
            break;
          case 'tips_relaP2Name':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP2Name = true;
            } else {
              this.tips_relaP2Name = false;
            }
            break;
          case 'tips_relaP1Tel':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP1Tel = true;
            } else {
              this.tips_relaP1Tel = false;
            }
            break;
          case 'tips_relaP2Tel':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP2Tel = true;
            } else {
              this.tips_relaP2Tel = false;
            }
            break;
          case 'tips_relaP2GX':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP2GX = true;
            } else {
              this.tips_relaP2GX = false;
            }
            break;
          case 'tips_relaP1GX':
            if (a.trim() == "" || a.trim() == null) {
              this.tips_relaP1GX = true;
            } else {
              this.tips_relaP1GX = false;
            }
            break;
        }
      },
      showModel(a) {
        this.show = true;
        this.values = a;
      },
      //关闭选择框
      onCancel() {
        this.show = false;
      },
      //选择框滚动时，表单内的值变化
      onChange(picker, value, index) {
        this[this.values] = value;
      },
      //确定选择的值
      onConfirm(value, index) {
        this[this.values] = value;
        this.show = false;
        this['tips_' + this.values] = false;
      },
      subInfo() {
        if (this.relaP1Name.trim() != "" && this.relaP2Name.trim() != "" && this.relaP1Tel.trim() != "" && this.relaP2Tel.trim() != "" && this.relaP1GX.trim() != "" && this.relaP2GX.trim() != "") {
          this.$store.commit('edit', true);//打开全局的loading
          let data = {
            relation_name1: this.relaP1Name,
            relation_name2: this.relaP2Name,
            mobile1: this.relaP1Tel,
            mobile2: this.relaP2Tel,
            relation2: this.relaP2GX,
            relation1: this.relaP1GX,
            userid: this.tk.userid,
            contacts_info: '',
            qq: '',
            weixin: ''
          };
          postContact(data)
            .then(res => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (res.data.code == 200) {
                this.$notify({
                  type: 'success', message: this.$t('message.add_success'), onClose: () => {
                    this.$router.push({path: '/home'});
                  }
                });
              } else {
                this.$notify({type: 'warning', message: this.$t('message.ipt_has_uIpt')});
                this.$store.commit('edit', false);//关闭全局的loading
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        } else {
          this.$notify({
            type: 'danger',
            message: this.$t('message.jcNEWS')
          });
          this.relaP1Name == "" || this.relaP1Name == null ? this.tips_relaP1Name = true : this.tips_relaP1Name = false;
          this.relaP2Name == "" || this.relaP2Name == null ? this.tips_relaP2Name = true : this.tips_relaP2Name = false;
          this.relaP2GX == "" || this.relaP2GX == null ? this.tips_relaP2GX = true : this.tips_relaP2GX = false;
          this.relaP1GX == "" || this.relaP1GX == null ? this.tips_relaP1GX = true : this.tips_relaP1GX = false;
          this.relaP1Tel == "" || this.relaP1Tel == null ? this.tips_relaP1Tel = true : this.tips_relaP1Tel = false;
          this.relaP2Tel == "" || this.relaP2Tel == null ? this.tips_relaP2Tel = true : this.tips_relaP2Tel = false;
        }
      },
      subInfoNext() {
        this.isPost = true;//禁用按钮

        if (this.relaP1Name.trim() != "" && this.relaP2Name.trim() != "" && this.relaP1Tel.trim() != "" && this.relaP2Tel.trim() != "" && this.relaP1GX.trim() != "" && this.relaP2GX.trim() != "") {
          this.$store.commit('edit', true);//打开全局的loading
          let restRZ = JSON.parse(localStorage.getItem('tempDate'));
          restRZ.mobile1 = this.relaP1Tel;
          restRZ.mobile2 = this.relaP2Tel;
          restRZ.relation1 = this.relaP1GX;
          restRZ.relation2 = this.relaP2GX;
          restRZ.relation_name1 = this.relaP1Name;
          restRZ.relation_name2 = this.relaP2Name;

          localStorage.setItem('tempDate', JSON.stringify(restRZ));//暂存重新认证的数据

          sassRestRZ(restRZ)
            .then(res => {
              let that = this;
              if (res.data.code == 200) {
                this.$notify({
                  type: 'success',
                  message: res.data.msg,
                  onClose: function () {
                    that.$router.push({path: '/schedule'});
                    localStorage.removeItem('tempDate');
                    sessionStorage.removeItem('restRZ');
                    that.$store.commit('edit', false);//关闭全局的loading
                    setTimeout(() => {
                      this.isPost = false;
                    }, 5000);
                  }
                });
              } else {
                this.$notify({type: 'danger', message: res.data.msg});
                this.$router.push({path: '/'});
                this.$store.commit('edit', false);//关闭全局的loading
                setTimeout(() => {
                  this.isPost = false;
                }, 5000);
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        } else {
          this.$notify({
            type: 'danger',
            message: this.$t('message.jcNEWS')
          });
          this.isPost = false;
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
    margin: 0.5rem 0;
  }

  /deep/ .van-cell.van-field {
    border-radius: 8px !important;
    border: 1px solid #cccccc !important;
  }

  .container {
    padding: 1.6rem 15px 0;

    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }

    .form_item {
      margin-bottom: 0.36rem;

      .form_label {
        color: #000000;
        font-size: 0.45rem;
        font-weight: 500;
        margin-bottom: 0.27rem;

        span {
          color: #FF0300;
          margin-right: 3px;
        }
      }
    }

    .tips {
      color: #B9B9B9;
      font-size: 0.33rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/Social.vue